import React, { useState, useEffect } from 'react';
import  { useLocation, useNavigate } from 'react-router-dom'
import { api } from '../utils/endpoint.js'

import TrackingDetailCompnent from '../components/TrackingDetailComponent.js'

function TrackDetailPage() {

  const navigate = useNavigate();
  const { state } = useLocation();
  const [ referenceNo, setReferenceNo ] = useState(state.referenceNo)

  useEffect(() => {
    window.scrollTo(0, 0)
    setReferenceNo(state.referenceNo)
    if (state.referenceNo !== "" ) {
      callApiGetTracking(state.referenceNo)
    }
  }, [state])



  async function callApiGetTracking( ref_no ) {

    await fetch(api.nonemcs.tracking(`ref_no=${ref_no}`))
    .then(response => response.json())
    .then(data => onSuccessCallApiGet(data), (error) => {
      if (error) {
        onFailCallApiGet(error )
      }
    });
  }
  async function onSuccessCallApiGet( data ){
    if(data) {  
      
    } else {
      gotoBack()
    }

  }
  async function onFailCallApiGet( error ){
    gotoBack()
  }

  function gotoBack() {
    navigate("/track", { replace: true })
  }

  return (
  <div className="w-full bg-white font-prompt ">
    <div className='flex flex-wrap w-full'>

      <TrackingDetailCompnent referenceNo={referenceNo} />

    </div>
  </div>
  )
}

export default TrackDetailPage;